module.exports = __webpack_public_path__ + "media/components/assets/img/bg/menu-10a05974e58acc27bf41100a6e3fbe21.png";